import React, { useState } from "react";
import DailyTaskModal from "./DailyTaskModal";
import { lang } from "../lang";
import MainActionButton from "./MainActionButton"; // Import the new component

// Component for task control buttons in Focused tab
function TaskControls({ addTask, defaultTaskDuration, addDailyTask }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddRestTask = (duration) => {
    const task = {
      name: `${lang.task.restTask} (${duration / 60} ${lang.task.minutes})`,
      duration,
      remaining: duration,
      isRest: true,
      paused: true,
      completed: false,
      isNew: true,
    };
    addTask(null, task);
  };

  const handleAddDeadlineTask = () => {
    const task = {
      name: lang.task.newTask,
      duration: defaultTaskDuration,
      remaining: defaultTaskDuration,
      isDeadline: true,
      hasDeadline: false,
      deadline: null,
      paused: true,
      completed: false,
      isNew: true,
    };
    addTask(null, task);
  };

  const handleSaveDailyTask = (taskData) => {
    addDailyTask(taskData);
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="button-container main-controls-container">
        <MainActionButton
          onClick={handleAddDeadlineTask}
          // className removed for unification, relies on base .main-action-button style
          title="Add a new task with a deadline"
        >
          {lang.app.addDeadlineTask}
        </MainActionButton>
        {/* <MainActionButton
          // className removed for unification
          onClick={() => handleAddRestTask(300)}
          title="Add a 5 minute rest task"
        >
          {lang.app.fiveMinRest}
        </MainActionButton>
        <MainActionButton
          // className removed for unification
          onClick={() => handleAddRestTask(1800)}
          title="Add a 30 minute rest task"
        >
          {lang.app.thirtyMinRest}
        </MainActionButton> */}
        <MainActionButton
          onClick={() => setIsModalOpen(true)}
          // className removed for unification
          title="Add a new daily recurring task"
        >
          Add Daily Task
        </MainActionButton>
      </div>
      <DailyTaskModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSaveDailyTask}
      />
    </>
  );
}

export default TaskControls;
